import { Platform, StyleSheet } from 'react-native';
import styled from 'styled-components/native';

import { neutralDark, warrior } from '../../../constants/color';
import { LIST_GAP } from '../styles';

export const ITEM_WIDTH = 130;
export const ITEM_MARGIN = 5;
export const LIST_CONTAINER_PADDING = 10;

export const S = {
  TitleSection: styled.View<{ width: number }>`
    margin: 20px ${LIST_GAP}px 10px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: ${({ width }) => width - LIST_GAP * 2}px;
    flex: 1;
  `,
  TitleText: styled.Text`
    color: ${warrior};
    font-size: 18px;
    line-height: 25px;
    font-weight: 700;
  `,
  MoreTopSalesText: styled.Text`
    color: ${neutralDark};
  `,
};

const styles = StyleSheet.create({
  horizontalListContainer: {
    paddingLeft: 10,
    paddingRight: 10,
  },
  watchMoreContainer: {
    marginLeft: 30,
    marginRight: 30,
    marginTop: 'auto',
    marginBottom: 'auto',
  },
  watchMoreTextSection: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  watchMoreText: {
    fontSize: 15,
    lineHeight: 21,
    color: warrior,
    marginTop: 8,
  },
  contentWrapperStyle: {
    minHeight: 70,
  },
  ListItemFontStyle: {
    fontSize: 13,
    lineHeight: 18,
  },
  moreTopSales: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  horizontalContainer: {
    paddingBottom: 0,
    marginBottom: 0,
    width: '100%',
    /*
      web 在外層的 View 需要給 flex: 1，FlatList 才能滾動，且需有 flex-basis: auto 才能顯示 list：
      https://github.com/necolas/react-native-web/issues/1436#issuecomment-612845122
    */
    ...Platform.select({
      web: {
        flex: 1,
        flexBasis: 'auto',
      },
    }),
  },
  listItemWrapperStyle: {
    marginTop: 'auto',
    marginBottom: 'auto',
  },
});

export default styles;
